import React from "react";
import { likeActu } from "../actions/actus";
import { tempAlWait } from "../helpers";
import { connect } from "react-redux";
import { faEye, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class LittleActu extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        data: null
    }

    componentDidMount() {
        this.setState({
            data: this.props.data
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.alert != prevState.alert) {
            this.props.changeAlert(this.state.alert);
        }

        if (prevProps.redLikeActu != this.props.redLikeActu) {
            if (this.props.redLikeActu.alert.type == "succ") {
                let tempData = this.state.data;
                if (tempData.isLike) {
                    tempData.isLike = false;
                    tempData.nbLike -= 1;
                } else {
                    tempData.isLike = true;
                    tempData.nbLike += 1;
                }
                this.setState({
                    alert: this.props.redLikeActu.alert,
                    data: tempData
                })
            } else {
                this.setState({
                    alert: this.props.redLikeActu.alert
                })
            }
        }
    }

    handleLike() {
        this.props.likeActu({actuId: this.state.data.id});
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <article className={`litart ${
            this.props.pageActu > this.props.indexer ? 
                "litart--prev" :
                (this.props.pageActu < this.props.indexer ?
                    "litart--next" : "")    
        }`}>
            <img
                src={`https://img.youtube.com/vi/${this.state.data?.codeYtb}/maxresdefault.jpg`}
                alt={this.state.data?.title}
                className="litart__minia"
            />
            <Link
                to={`/article/${this.state.data?.id}`}
                title="Consulter l'article"
                aria-label="Consulter l'article"
                className="litart__link"
            >{this.state.data?.title}</Link>
            <footer className="litart__ftr">
                <div className="litart__nber">
                    <FontAwesomeIcon icon={faEye} />
                    <span className="litart__nbertxt">{this.state.data?.nbVue}</span>
                </div>
                <button
                    title={this.state.data?.isLike ? "Je n'aime plus" : "J'aime"}
                    aria-label={this.state.data?.isLike ? "Je n'aime plus" : "J'aime"}
                    className={`litart__nber litart__nber--like ${this.state.data?.isLike && "litart__nber--isLike"}`}
                    onClick={() => this.handleLike()}
                >   
                    <FontAwesomeIcon icon={faHeart} />
                    {
                        this.state.data?.nbLike > 0 &&
                        <span className="litart__nbertxt">{this.state.data?.nbLike}</span>
                    }
                </button>
            </footer>
        </article>
    }
}

const mapStateToProps = state => {
    return {
        redLikeActu: state.redLikeActu
    }
}

const mapDispatchToProps = {
    likeActu
}

export default connect(mapStateToProps, mapDispatchToProps)(LittleActu);